module.exports = __webpack_public_path__ + "static/img/project01.9670e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project01.png
// module id = zPQ9
// module chunks = 1